import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root introuvable dans index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the dedicated push service worker under its OWN scope — '/' is
// owned by the Workbox SW from vite-plugin-pwa, and two registrations on the
// same scope replace each other (push toggle desynchronisé, séance de test
// 2026-08 — Frappe 2). Same scope as usePushNotifications.PUSH_SCOPE.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/push-sw.js', { scope: '/push/' })
    .catch(() => {
      /* push registration failure is non-fatal */
    });

  // Migration (baptême du feu, QA/Sènami) : un navigateur abonné AVANT le
  // passage au scope /push/ garde une souscription orpheline sur l'ancienne
  // registration de push-sw.js en scope '/'. On la résilie — best-effort,
  // sans jamais toucher le SW Workbox de la PWA (même scope '/', mais
  // scriptURL différente).
  navigator.serviceWorker
    .getRegistrations()
    .then(async (regs) => {
      for (const reg of regs) {
        const script = reg.active?.scriptURL ?? reg.installing?.scriptURL ?? reg.waiting?.scriptURL;
        const estAncienPushSw =
          script?.endsWith('/push-sw.js') && new URL(reg.scope).pathname === '/';
        if (estAncienPushSw) {
          const sub = await reg.pushManager.getSubscription().catch(() => null);
          await sub?.unsubscribe().catch(() => undefined);
          await reg.unregister().catch(() => undefined);
        }
      }
    })
    .catch(() => {
      /* migration best-effort */
    });
}
